/**
 * @Author: v_jppjpeng
 * @Date: 2023-09-19 16:17:00
 * @Explain: 分层管理
 */

export interface SegmentsManageState {
  /** 创建分层 - 弹窗配置 */
  createSegmentOptions: {
    isShow: boolean;
  };
  /** 内置分层 - 展开收起 */
  builtExpandedList: any[];
}

export type ModelType = {
  namespace: string;
  state: SegmentsManageState;
  reducers: {
    setCreateSegmentOptions: (
      state: SegmentsManageState,
      action: { payload: any },
    ) => any;
    setBuiltExpandedList: (
      state: SegmentsManageState,
      action: { payload: any },
    ) => any;
  };
};

const SegmentsManageModel: ModelType = {
  namespace: 'SegmentsManageModel',
  state: {
    // 创建分层 - 弹窗配置
    createSegmentOptions: { isShow: false },
    // 内置分层 - 展开收起
    builtExpandedList: [],
  },
  reducers: {
    // 创建分层 - 弹窗配置设置
    setCreateSegmentOptions(state, action) {
      console.log('action.payload', action.payload);

      return {
        ...state,
        createSegmentOptions: action.payload,
      };
    },
    // 设置内置分层 - 展开收起
    setBuiltExpandedList(state, action) {
      return {
        ...state,
        builtExpandedList: action.payload,
      };
    },
  },
};

export default SegmentsManageModel;
